"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getListNextOffsetByParams = exports.getListTotalByParams = exports.hasCommitFailedByParams = exports.isCommittingByParams = exports.getListResultsByParams = exports.listByParametersDomain = exports.getParametersKeyFromProps = exports.listDomainSelector = exports.getListNextOffset = exports.getListTotal = exports.hasCommitFailed = exports.isCommiting = exports.getListResults = exports.getListByParametersDomain = exports.getListParametersSerialized = exports.getListParameters = exports.listDomain = exports.listReducer = exports.commitWithParams = exports.commit = exports.setParams = exports.initialize = exports.formatParameters = exports.CommitError = void 0;
var tslib_1 = require("tslib");
var reselect_1 = require("reselect");
var typescript_fsa_1 = tslib_1.__importDefault(require("typescript-fsa"));
var typescript_fsa_reducers_1 = require("typescript-fsa-reducers");
var immutable_1 = require("immutable");
var CommitError = /** @class */ (function (_super) {
    tslib_1.__extends(CommitError, _super);
    function CommitError(error) {
        if (error === void 0) { error = true; }
        var _this = _super.call(this, 'Commit Error') || this;
        _this.error = undefined;
        _this.name = 'CommitError';
        _this.error = error;
        _this.name = 'CommitError';
        return _this;
    }
    return CommitError;
}(Error));
exports.CommitError = CommitError;
var getProp = function (object, path, defaultValue) {
    if (defaultValue === void 0) { defaultValue = undefined; }
    if (path === undefined || path === null) {
        return defaultValue;
    }
    var pathArray = path;
    var val = pathArray.reduce(function (o, x) {
        return typeof o === 'undefined' || o === null ? defaultValue : o[x];
    }, object);
    if (typeof val === 'undefined' || val === null) {
        return defaultValue;
    }
    return val;
};
var setPropInObject = function (originObject, path, iteration, setObject) {
    var _a;
    if (path[iteration]) {
        return tslib_1.__assign(tslib_1.__assign({}, originObject), (_a = {}, _a[path[iteration]] = path[iteration + 1]
            ? tslib_1.__assign({}, setPropInObject(getProp(originObject, [path[iteration]], {}), path, iteration + 1, setObject)) : setObject, _a));
    }
};
var setProp = function (originObject, path, setObject) {
    var result = setPropInObject(originObject, path, 0, setObject);
    return result;
};
var formatParameters = function (parameters) {
    return Object.keys(parameters)
        .sort()
        .map(function (param) {
        if (param && typeof parameters[param] !== 'undefined') {
            return "".concat(param, "=").concat(parameters[param].toString());
        }
        return null;
    })
        .filter(function (v) { return v; })
        .join('&');
};
exports.formatParameters = formatParameters;
var actionCreator = (0, typescript_fsa_1.default)('@@redux-list');
exports.initialize = actionCreator('INITIALIZE');
exports.setParams = actionCreator('PARAMS_SET');
var commitActions = actionCreator.async('COMMIT');
var isCommitError = function (error) {
    return error && error.name === CommitError.name;
};
var commitAsync = function (payload) {
    return function (dispatch, getState) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var key, result, commitError_1, error;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    key = (0, exports.getListParametersSerialized)(payload.listName)(getState());
                    dispatch(commitActions.started({
                        listName: payload.listName,
                        key: key,
                    }));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, payload.load()];
                case 2:
                    result = _a.sent();
                    dispatch(commitActions.done({
                        params: {
                            listName: payload.listName,
                            key: key,
                        },
                        result: result,
                    }));
                    return [3 /*break*/, 4];
                case 3:
                    commitError_1 = _a.sent();
                    error = isCommitError(commitError_1) ? commitError_1 : undefined;
                    if (error) {
                        dispatch(commitActions.failed({
                            params: {
                                listName: payload.listName,
                                key: key,
                            },
                            error: error.error,
                        }));
                        return [2 /*return*/, error];
                    }
                    else {
                        throw commitError_1;
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.commit = {
    action: commitAsync,
    async: commitActions,
};
var commitWithParamsAsync = function (payload) {
    return function (dispatch) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var key, result, commitError_2, error;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    key = (0, exports.formatParameters)(payload.params);
                    dispatch(commitActions.started({
                        listName: payload.listName,
                        key: key,
                    }));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, payload.load()];
                case 2:
                    result = _a.sent();
                    dispatch(commitActions.done({
                        params: {
                            listName: payload.listName,
                            key: key,
                        },
                        result: result,
                    }));
                    return [3 /*break*/, 4];
                case 3:
                    commitError_2 = _a.sent();
                    error = isCommitError(commitError_2) ? commitError_2 : undefined;
                    if (error) {
                        dispatch(commitActions.failed({
                            params: {
                                listName: payload.listName,
                                key: key,
                            },
                            error: error.error,
                        }));
                        return [2 /*return*/, error];
                    }
                    else {
                        throw commitError_2;
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.commitWithParams = {
    action: commitWithParamsAsync,
    async: commitActions,
};
var INITIAL_STATE = {};
var listReducer = (0, typescript_fsa_reducers_1.reducerWithInitialState)(INITIAL_STATE)
    .case(exports.initialize, function (state, _a) {
    var listName = _a.listName, initialParams = _a.initialParams;
    return (tslib_1.__assign({}, setProp(state, [listName], {
        id: listName,
        parameters: initialParams || {},
        byParameters: {},
    })));
})
    .case(exports.setParams, function (state, payload) { return (tslib_1.__assign({}, setProp(state, [payload.listName, 'parameters'], payload.parameters))); })
    .case(exports.commit.async.started, function (state, _a) {
    var key = _a.key, listName = _a.listName;
    return (tslib_1.__assign({}, setProp(state, [listName, 'byParameters', key], tslib_1.__assign(tslib_1.__assign({}, getProp(state, [listName, 'byParameters', key], {})), { isCommitting: true }))));
})
    .case(exports.commit.async.failed, function (state, _a) {
    var _b = _a.params, key = _b.key, listName = _b.listName, error = _a.error;
    return (tslib_1.__assign({}, setProp(state, [listName, 'byParameters', key], {
        isCommitting: false,
        error: error,
    })));
})
    .case(exports.commit.async.done, function (state, _a) {
    var _b = _a.params, key = _b.key, listName = _b.listName, result = _a.result;
    return (tslib_1.__assign({}, setProp(state, [listName, 'byParameters', key], {
        isCommitting: false,
        nextOffset: result.nextOffset,
        total: result.total,
        results: result.results,
        error: undefined,
    })));
});
exports.listReducer = listReducer;
var listsDomain = function (state) {
    return (0, immutable_1.isImmutable)(state)
        ? state.get('list')
        : getProp(state, ['list'], {});
};
var listDomain = function (listName) {
    return (0, reselect_1.createSelector)(listsDomain, function (substate) {
        return substate[listName] || {};
    });
};
exports.listDomain = listDomain;
var getListParameters = function (listName) {
    return (0, reselect_1.createSelector)((0, exports.listDomain)(listName), function (substate) {
        return substate.parameters || {};
    });
};
exports.getListParameters = getListParameters;
var getListParametersSerialized = function (listName) {
    return (0, reselect_1.createSelector)((0, exports.getListParameters)(listName), function (substate) {
        return Object.keys(substate)
            .sort()
            .map(function (param) {
            if (param) {
                return "".concat(param, "=").concat(substate[param].toString());
            }
            return null;
        })
            .filter(function (v) { return v; })
            .join('&');
    });
};
exports.getListParametersSerialized = getListParametersSerialized;
var getListByParametersDomain = function (listName) {
    return (0, reselect_1.createSelector)((0, exports.listDomain)(listName), (0, exports.getListParametersSerialized)(listName), function (substate, key) {
        if (substate.byParameters) {
            return substate.byParameters[key];
        }
        return null;
    });
};
exports.getListByParametersDomain = getListByParametersDomain;
var getListResults = function (listName) {
    return (0, reselect_1.createSelector)((0, exports.getListByParametersDomain)(listName), function (substate) {
        return substate && substate.results;
    });
};
exports.getListResults = getListResults;
var isCommiting = function (listName) {
    return (0, reselect_1.createSelector)((0, exports.getListByParametersDomain)(listName), function (substate) {
        return substate && substate.isCommitting;
    });
};
exports.isCommiting = isCommiting;
var hasCommitFailed = function (listName) {
    return (0, reselect_1.createSelector)((0, exports.getListByParametersDomain)(listName), function (substate) {
        return !!(substate && substate.error);
    });
};
exports.hasCommitFailed = hasCommitFailed;
var getListTotal = function (listName) {
    return (0, reselect_1.createSelector)((0, exports.getListByParametersDomain)(listName), function (substate) {
        return substate && substate.total;
    });
};
exports.getListTotal = getListTotal;
var getListNextOffset = function (listName) {
    return (0, reselect_1.createSelector)((0, exports.getListByParametersDomain)(listName), function (substate) {
        return substate && substate.nextOffset;
    });
};
exports.getListNextOffset = getListNextOffset;
exports.listDomainSelector = (0, reselect_1.createSelector)(listsDomain, function (_, _a) {
    var listName = _a.listName;
    return listName;
}, function (substate, listName) {
    return substate[listName] || {};
});
var getParametersKeyFromProps = function (_, _a) {
    var parameters = _a.parameters;
    return (0, exports.formatParameters)(parameters);
};
exports.getParametersKeyFromProps = getParametersKeyFromProps;
exports.listByParametersDomain = (0, reselect_1.createSelector)(exports.listDomainSelector, exports.getParametersKeyFromProps, function (substate, key) {
    if (substate.byParameters) {
        return substate.byParameters[key];
    }
    return null;
});
exports.getListResultsByParams = (0, reselect_1.createSelector)(exports.listByParametersDomain, function (substate) {
    return substate && substate.results;
});
exports.isCommittingByParams = (0, reselect_1.createSelector)(exports.listByParametersDomain, function (substate) {
    return substate && substate.isCommitting;
});
exports.hasCommitFailedByParams = (0, reselect_1.createSelector)(exports.listByParametersDomain, function (substate) {
    return !!(substate && substate.error);
});
exports.getListTotalByParams = (0, reselect_1.createSelector)(exports.listByParametersDomain, function (substate) {
    return substate && substate.total;
});
exports.getListNextOffsetByParams = (0, reselect_1.createSelector)(exports.listByParametersDomain, function (substate) {
    return substate && substate.nextOffset;
});
